module.exports = __webpack_public_path__ + "static/media/logo-handdrawing.7f078a2b.png";